import { motion } from "framer-motion";
import classes from "../More.module.css";

const TermsConditions = () => {
  return (
    <motion.div
      className={classes.page}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1>Terms & Conditions</h1>
<p>Effective Date: September 28, 2025</p>

<p>
Welcome to <strong>dothink</strong>. By accessing or using our service, you agree to be bound 
by these Terms & Conditions. Please read them carefully. If you do not agree, 
you may not use the service.
</p>

<h2>1. Use of Service</h2>
<p>
You may use our service only for lawful purposes and in accordance with these Terms. 
You agree not to use the service:
</p>
<ul>
  <li>In any way that violates applicable laws or regulations.</li>
  <li>To exploit, harm, or attempt to exploit or harm minors.</li>
  <li>To transmit spam, malware, or harmful content.</li>
  <li>To attempt unauthorized access to our systems or interfere with the security of the service.</li>
</ul>

<h2>2. Accounts</h2>
<p>
When you create an account, you must provide accurate and complete information. 
You are responsible for maintaining the confidentiality of your account credentials and 
for all activities that occur under your account. You agree to notify us immediately of any 
unauthorized use or security breach.
</p>

<h2>3. Intellectual Property</h2>
<p>
All content, features, and functionality of dothink (including text, graphics, 
logos, and software) are owned by dothink or its licensors and are protected 
by intellectual property laws. You may not copy, modify, distribute, or create 
derivative works without our prior written consent.
</p>

<h2>4. User Content</h2>
<p>
You retain ownership of any content you submit (e.g., questions, answers, mindmaps), 
but you grant dothink a worldwide, non-exclusive, royalty-free license to use, 
display, and distribute such content solely for operating and improving the service.  
</p>

<h2>5. Termination</h2>
<p>
We reserve the right to suspend or terminate your access to the service at our sole discretion, 
without notice, if you violate these Terms or engage in harmful behavior. Upon termination, 
your right to use the service will immediately cease.
</p>

<h2>6. Limitation of Liability</h2>
<p>
To the maximum extent permitted by law, dothink and its affiliates shall not be liable 
for any indirect, incidental, special, or consequential damages, including loss of profits, 
data, or goodwill, arising out of your use or inability to use the service.
</p>

<h2>7. Disclaimer of Warranties</h2>
<p>
The service is provided on an "as is" and "as available" basis. We make no warranties, 
express or implied, regarding the reliability, availability, or suitability of the service 
for your purposes.
</p>

<h2>8. Governing Law</h2>
<p>
These Terms shall be governed by and construed in accordance with the laws of 
California, without regard to its conflict of law provisions. Any disputes 
arising under these Terms shall be resolved exclusively in the courts located in 
California.
</p>

<h2>9. Changes to Terms</h2>
<p>
We may update these Terms & Conditions from time to time. If changes are made, 
we will notify you by updating the date at the top of this page. Your continued use 
of the service after such changes constitutes acceptance of the new Terms.
</p>

<h2>10. Contact Us</h2>
<p>
If you have any questions about these Terms, please contact us at:  
<strong> james1023417@gmail.com</strong>.
</p>

    </motion.div>
  );
};

export default TermsConditions;
